import { Scene, FullScreenBackgroundFill } from "onearm";
import { Signal } from "typed-signals";
import { formatCurrency } from "../../utils/formatCurrency.js";

export class InfoPopupScene extends Scene {
    constructor(parameters) {
        super({ layer: "popups", name: "InfoPopupScene", ...parameters });
    }

    create(options) {
        super.create(options);

        const { screen, paytable, bet = 1, currency = "" } = options;

        this.onPressClose = new Signal();

        this.fill = this.addChildAt(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        0);

        this.pagesContainer = this.layout.find("pagesContainer");
        this.pageCount = this.pagesContainer?.children?.length ?? 0;

        this.layout.forAll("PageControls.RightButton", (btn) => {
            btn.onPress.connect(this.handlePressNext.bind(this));
        });
        this.layout.forAll("PageControls.LeftButton", (btn) => {
            btn.onPress.connect(this.handlePressPrev.bind(this));
        });

        this.layout.forAll("CloseButton", (btn) => {
            btn.onPress.connect(() => this.onPressClose.emit());
        });

        if (paytable) {
            this._fillPaytable(paytable, bet, currency);
        }

        this.currentPage = 0;
        if (this.pageCount > 0) {
            this.updatePageNumber(this.currentPage);
        }
    }

    _fillPaytable(paytable, bet, currency) {
        const lines = [
            { name: "pay-line-1", count: 5, index: 2 },
            { name: "pay-line-2", count: 4, index: 1 },
            { name: "pay-line-3", count: 3, index: 0 },
        ];

        for (const [symbolName, multipliers] of Object.entries(paytable)) {
            const pays = this.layout.find(`Symbol${symbolName}`)?.find("pays");
            if (!pays) continue;

            for (const { name, count, index } of lines) {
                const text = pays.find(name);
                if (!text) continue;
                text.text = `${count}  ${formatCurrency(multipliers[index] * bet, currency)}`;
            }
        }
    }

    handlePressNext() {
        if (this.pageCount <= 0) return;
        this.currentPage = (this.currentPage + 1) % this.pageCount;
        this.updatePageNumber(this.currentPage);
    }

    handlePressPrev() {
        if (this.pageCount <= 0) return;
        this.currentPage = (this.currentPage - 1 + this.pageCount) % this.pageCount;
        this.updatePageNumber(this.currentPage);
    }

    updatePageNumber(page) {
        this.currentPage = page;

        this.layout.forAll("pagesContainer", (container) => {
            container.children.forEach((child, index) => {
                child.visible = index === page;
            });
        });

        this.layout.forAll("PageNumber", (text) => {
            text.text = `Page ${page + 1}/${this.pageCount}`;
        });
    }
}
